import api from './api';

const BASE_PATH = '/api/education-results';

const educationResultService = {
    getCaptcha: (sessionToken) =>
        api.get(`${BASE_PATH}/captcha`, {
            params: sessionToken ? { sessionToken } : undefined,
        }),

    fetchResult: (payload) =>
        api.post(`${BASE_PATH}/fetch`, payload),
};

export default educationResultService;
